export const SHIP_BELL_SOUND = '/static/sounds/shipsbell.wav';
export const DING_SOUND = '/static/sounds/shipsbell.wav';

export const playSound = (src) => {
  const snd = new Audio(src);
  snd.play();
};
